import Vue from 'vue';
import Vuex from 'vuex';
import moment from 'moment';

import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import modules from './modules';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const state = {
  auth: {
    token: null,
    pin: null,
  },
  device: {},
  bookings: [],
  space: {},
  spaces: [],
  capAlertURLs: [],
  cards: {
    goTo: (new Date().getHours()),
  },
  startPinCountDown: true,
  selectedDate: moment(),
  isOfflineMode: !navigator.onLine,
};

export default new Vuex.Store({
  strict: debug,
  state,
  actions,
  mutations,
  getters,
  modules,
});



// WEBPACK FOOTER //
// ./src/store/index.js